/** Company details stamped onto new documents, e.g. KS-rapporter. */
export const company = {
  name: 'Lykke-EL',
  email: 'kontakt@lykke-el.dk',
  website: 'www.lykke-el.dk',
}
